import Card from "components/card";
import DonutChart from "components/charts/DonutChart";
import Loader from "components/loader";
import { getInstituciones } from "services/Reports";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";
import { DASHBOARD_COLORS } from "utils/dashboardColors";

const donutOptions = {
  chart: {
    type: "donut",
  },
  labels: ["Gold", "Standard"],
  colors: [DASHBOARD_COLORS.gold, DASHBOARD_COLORS.otros],
  legend: {
    show: true,
    position: "bottom",
  },
  dataLabels: {
    enabled: true,
  },
  tooltip: {
    theme: "dark",
  },
};

const PlansDistributionWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [instituciones, setInstituciones] = useState([]);

  const fetchInstituciones = async () => {
    setIsLoading(true);
    const data = await getInstituciones();
    const rows = Array.isArray(data?.[0]) ? data[0] : [];
    setInstituciones(rows);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchInstituciones();
  }, []);

  const { gold, standard } = useMemo(() => {
    return instituciones.reduce(
      (acc, item) => {
        const plan = item?.user?.plan?.detalle?.nombre;
        if (plan === "Gold") {
          acc.gold += 1;
        } else {
          acc.standard += 1;
        }
        return acc;
      },
      { gold: 0, standard: 0 }
    );
  }, [instituciones]);

  return (
    <Card extra="w-full h-full px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Distribución de planes
        </div>
        <Link
          to={routesNames.INSTITUCIONES}
          className="text-sm hover:cursor-pointer bg-lightPrimary p-2 text-navy-700 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10 linear justify-center rounded-lg font-semibold transition duration-200"
        >
          Ver instituciones
        </Link>
      </div>

      <div className="mt-4 flex h-[220px] w-full items-center justify-center">
        {isLoading ? (
          <Loader />
        ) : (
          <DonutChart options={donutOptions} series={[gold, standard]} />
        )}
      </div>
    </Card>
  );
};

export default PlansDistributionWidget;
